import { render, staticRenderFns } from "./CustomerSurveyDetail.vue?vue&type=template&id=d13fa944&"
import script from "./CustomerSurveyDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerSurveyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports